import { layout } from "@app/domain";
import { useEffect, useState } from "react";

/** The single scale for the scene (ADR 0011). Re-measured on resize and rotation. */
export function useMeasure(): layout.Measure {
  const [measure, setMeasure] = useState(() =>
    layout.measure({ width: window.innerWidth, height: window.innerHeight }),
  );
  useEffect(() => {
    const update = () =>
      setMeasure(layout.measure({ width: window.innerWidth, height: window.innerHeight }));
    window.addEventListener("resize", update);
    window.visualViewport?.addEventListener("resize", update);
    return () => {
      window.removeEventListener("resize", update);
      window.visualViewport?.removeEventListener("resize", update);
    };
  }, []);
  return measure;
}
